/* istanbul ignore file */
export enum LoadingActionTypesEnum {
    SHOW_LOADING = 'loading/show',
    HIDE_LOADING = 'loading/hide'
}
